"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTwapContext = exports.TwapAdapter = exports.TwapContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var hooks_1 = require("./hooks");
var en_json_1 = __importDefault(require("./i18n/en.json"));
var react_query_1 = require("@tanstack/react-query");
var analytics_1 = require("./analytics");
var store_1 = require("./store");
var ErrorHandling_1 = require("./ErrorHandling");
var components_1 = require("./components");
analytics_1.analytics.onModuleLoad();
exports.TwapContext = (0, react_1.createContext)({});
var queryClient = new react_query_1.QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});
var useLimitPriceUpdater = function () {
    var setLimitOrderPriceUi = (0, store_1.useTwapStore)(function (store) { return store.setLimitOrderPriceUi; });
    var isLimitOrder = (0, store_1.useTwapStore)(function (store) { return store.isLimitOrder; });
    var custom = (0, hooks_1.useLimitPrice)().custom;
    var srcUsd = (0, store_1.useTwapStore)(function (store) { return store.srcUsd; });
    var dstUsd = (0, store_1.useTwapStore)(function (store) { return store.dstUsd; });
    (0, react_1.useEffect)(function () {
        if (isLimitOrder && !custom && !srcUsd.isZero() && !dstUsd.isZero()) {
            setLimitOrderPriceUi();
        }
    }, [custom, srcUsd, dstUsd, setLimitOrderPriceUi, isLimitOrder]);
};
var Listener = function () {
    var setTokensFromDappCallback = (0, hooks_1.useSetTokensFromDapp)();
    useLimitPriceUpdater();
    (0, react_1.useEffect)(function () {
        setTokensFromDappCallback();
    }, [setTokensFromDappCallback]);
    return null;
};
var WrappedTwap = function (props) {
    var updateStoreOveride = (0, hooks_1.useUpdateStoreOveride)();
    var initLib = (0, hooks_1.useInitLib)();
    (0, react_1.useEffect)(function () {
        analytics_1.analytics.onTwapPageView();
    }, []);
    (0, react_1.useEffect)(function () {
        updateStoreOveride(props.storeOverride);
    }, [updateStoreOveride, props.storeOverride]);
    // init web3 every time the provider changes
    (0, react_1.useEffect)(function () {
        initLib({ config: props.config, provider: props.provider, account: props.account, connectedChainId: props.connectedChainId });
    }, [props.provider, props.config, props.account, props.connectedChainId]);
    return ((0, jsx_runtime_1.jsxs)(ErrorHandling_1.TwapErrorWrapper, { children: [(0, jsx_runtime_1.jsx)(Listener, {}), (0, jsx_runtime_1.jsx)(components_1.Wizard, {}), props.children] }));
};
var TwapAdapter = function (props) {
    var translations = (0, react_1.useMemo)(function () { return (__assign(__assign({}, en_json_1.default), props.translations)); }, [props.translations]);
    var tokenList = (0, hooks_1.useParseTokens)(props.dappTokens, props.parseToken);
    return ((0, jsx_runtime_1.jsx)(react_query_1.QueryClientProvider, __assign({ client: queryClient }, { children: (0, jsx_runtime_1.jsx)(exports.TwapContext.Provider, __assign({ value: __assign(__assign({}, props), { translations: translations, tokenList: tokenList, uiPreferences: props.uiPreferences || {} }) }, { children: (0, jsx_runtime_1.jsx)(WrappedTwap, __assign({}, props)) })) })));
};
exports.TwapAdapter = TwapAdapter;
var useTwapContext = function () {
    return (0, react_1.useContext)(exports.TwapContext);
};
exports.useTwapContext = useTwapContext;
